import React from 'react';
import { Tooltip } from 'antd';
import classNames from 'classnames';

const CompoundSideListItem = ({ item, active, onPreview, children }) => {
  return (
    <Tooltip placement="bottom" title={item.name} mouseEnterDelay={1}>
      <a
        onClick={() => onPreview(item)}
        onKeyDown={() => {}}
        className={classNames('item-container', active && 'active')}
      >
        <div className="item">
          <span>{item.name}</span>
          {children}
        </div>
      </a>
    </Tooltip>
  );
};

export default CompoundSideListItem;
